import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import axios from "axios";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import "./LoginComponent.sass";

import { toast } from "react-toastify";

function FormLogin({ setters, handler, msg }) {
  const [setEmail, setPassword] = setters;
  const handleLogin = handler;

  const [openModal, setModalOpen] = useState(false);
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const [emailReset, setEmailReset] = useState();

  const onSendEmail = async (e) => {
    e.preventDefault();

    if (emailReset == null || emailReset == "") {
      toast.info("Preencha o e-mail", {
        theme: "colored",
      });

      return;
    }

    const body = {
      emailReset,
    };

    await axios
      .post(process.env.REACT_APP_API_URL + "user/send-email-reset-pwd", body)
      .then((response) => {
        return toast.success("Foi enviado um e-mail para redefinir a senha", {
          theme: "colored",
        });
      })
      .catch((error) => {
        console.log(error);
        return toast.error("Ocorreu um erro ao enviar o e-mail", {
          theme: "colored",
        });
      });
  };

  return (
    <form onSubmit={!openModal ? handleLogin : null}>
      <div className="form-header">
        <span className="font text-4">Iniciar sessão</span>
      </div>

      <div className="form-content">
        <label htmlFor="user" className="font text-2">
          E-mail
        </label>
        <input
          type="text"
          name="user"
          id="user"
          onChange={(event) => {
            setEmail(event.target.value);
          }}
        />
        <label htmlFor="pass" className="font text-2">
          Senha
        </label>
        <input
          type="password"
          name="pass"
          id="pass"
          onChange={(event) => {
            setPassword(event.target.value);
          }}
        />
        <input
          type="submit"
          value="Enviar"
          className="action-btn"
          disabled={openModal}
        />
        <span className="forgot-pass font text-1" onClick={handleOpenModal}>
          Esqueci minha senha
        </span>
      </div>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="box-modal form-wrapper">
          <form onSubmit={onSendEmail}>
            <div className="form-header">
              <span className="font text-4">Redefinição de senha</span>
            </div>
            <div className="form-content">
              <label htmlFor="contract" className="font text-2">
                Insira seu e-mail
              </label>
              <input
                type="text"
                name="user"
                id="user"
                onChange={(event) => {
                  setEmailReset(event.target.value);
                }}
              />
              <input
                type="submit"
                value="Enviar e-mail"
                className="action-btn"
              />
            </div>
          </form>
          <div className="aside-img-div">
            <img src="/assets/images/logo.png" className="bottom-form-logo" />
          </div>
        </Box>
      </Modal>
    </form>
  );
}

function FormCodeInsertion({ setter, handler, msg, email, blocked }) {
  const handleCodeAttempt = handler;
  const setCode = setter;

  return (
    <form onSubmit={handleCodeAttempt}>
      <div className="form-header">
        <span className="font text-4">Iniciar sessão</span>
      </div>

      {msg === null ? (
        <div className="form-msg alert-success">
          <span className="font text-2">
            <b>E-mail Enviado!</b> Enviamos um código para o e-mail{" "}
            <b>{email}</b> e o código expira em 5min.
          </span>
        </div>
      ) : (
        <div className="form-msg alert-failure">
          <span className="font text-2">
            <b>{msg}</b>
          </span>
        </div>
      )}

      <div className="form-content">
        <label htmlFor="user" className="font text-2">
          Código
        </label>
        <input
          type="text"
          name="user"
          id="user"
          disabled={blocked}
          onChange={(event) => {
            setCode(event.target.value);
          }}
        />
        <input
          type="submit"
          value="Enviar"
          className="action-btn"
          disabled={blocked}
        />
      </div>
    </form>
  );
}

function LoginComponent() {
  const navigate = useNavigate();
  const { login, logout } = useAuth();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [userId, setUserId] = useState();

  const [code, setCode] = useState();
  const [codeSent, setCodeSent] = useState(false);

  const [msg, setMsg] = useState(null);

  const [codeBlockedUntil, setCodeBlockedUntil] = useState(null);
  const isCodeBlocked =
    codeBlockedUntil !== null && Date.now() < codeBlockedUntil;

  useEffect(() => {
    if (!codeBlockedUntil) return;
    const remainingMs = codeBlockedUntil - Date.now();
    if (remainingMs <= 0) {
      setCodeBlockedUntil(null);
      return;
    }
    const t = setTimeout(() => setCodeBlockedUntil(null), remainingMs);
    return () => clearTimeout(t);
  }, [codeBlockedUntil]);

  const handleLogin = async (e) => {
    e.preventDefault();

    const body = {
      email,
      password,
    };

    if (
      email === undefined ||
      email === "" ||
      password === undefined ||
      password === ""
    ) {
      toast.info("Preencha os campos", {
        theme: "colored",
      });
    } else {
      await axios
        .post(process.env.REACT_APP_API_URL + "auth/send-token", body)
        .then((response) => {
          setUserId(response.data.userId);
          setMsg(response.status === 200 ? null : response.data.message);
          setCodeSent(response.status === 200 ? true : false);
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message || "Erro na autenticação";
          toast.error(errorMessage, {
            theme: "colored",
          });
        });
    }
  };

  const handleCodeAttempt = async (e) => {
    e.preventDefault();

    if (isCodeBlocked) {
      toast.error("Erro na autenticação", {
        theme: "colored",
      });
      return;
    }

    const body = {
      userId,
      email,
      code,
    };

    if (code === undefined || code === "") {
      toast.info("Preencha o campo", {
        theme: "colored",
      });
    } else {
      await axios
        .post(process.env.REACT_APP_API_URL + "auth/auth", body)
        .then((response) => {
          if (response.status === 200 && response.data.status === 200) {
            login({ email, userId, name: response.data.username });
            localStorage.setItem("isAdmin", response.data.isAdmin);
            localStorage.setItem("token", response.data.token);
            localStorage.setItem(
              "tokenExpiration",
              response.data.tokenExpiration,
            );
            navigate("/incident");
          } else {
            logout();
            localStorage.removeItem("isAdmin");
            localStorage.removeItem("token");
            localStorage.removeItem("tokenExpiration");
            const errorMessage =
              response.data?.message ||
              response.data?.msg ||
              "Erro na autenticação";
            toast.error(errorMessage, {
              theme: "colored",
            });
          }
        })
        .catch((error) => {
          if (error.response?.status === 429) {
            setCodeBlockedUntil(Date.now() + 10 * 60 * 1000);
          }
          const errorMessage =
            error.response?.data?.message || "Erro na autenticação";
          toast.error(errorMessage, {
            theme: "colored",
          });
        });
    }
  };

  return (
    <div className="form-wrapper">
      {!codeSent ? (
        <FormLogin
          setters={[setEmail, setPassword]}
          handler={handleLogin}
          msg={msg}
        />
      ) : (
        <FormCodeInsertion
          setter={setCode}
          handler={handleCodeAttempt}
          msg={msg}
          email={email}
          blocked={isCodeBlocked}
        />
      )}
      <div className="aside-img-div">
        <img src="/assets/images/logo.png" className="bottom-form-logo" />
      </div>
    </div>
  );
}

export default LoginComponent;
